import * as React from 'react';
import { BaseBlockView } from '../base-block.view';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../../interface/component/injected-props.interface';
import { TableRowBlockModel } from '../../../model/block';
import styled from 'styled-components';
import { DraftToHtml } from '../../draft-to-html/draft-to-html';
import { getCenterOfPageStyle } from '../../../util/style/get-center-of-page-style';
import { isDraftEmpty } from '../../../util/draft/is-draft-empty.util';
import { findLinkedDataById } from '../../../util/page/find-linked-data-by-id.util';
import { ITableCell, CellBorderOptions, RowBorderOptions } from '../../../interface/component/table-cell.interface';
interface ITextBlockWrapperProps {
  backgroundColor: string;
  hasPadding: boolean;
  isSelected: boolean;
  border: RowBorderOptions;
}
interface ICellStyleProps {
  border: CellBorderOptions;
  isSelected?: boolean;
}
// interface IRowStyleProps {
//   border: RowBorderOptions;
//   isSelected?: boolean;
// }
const CellBorderStyle = {
  [CellBorderOptions.LEFT]: (borderWidth: number) => `border-left:${borderWidth}px solid black`,
  [CellBorderOptions.RIGHT]: (borderWidth: number) => `border-right:${borderWidth}px solid black`,
  [CellBorderOptions.BOTH]: (borderWidth: number) => `border-right:${borderWidth}px solid black; border-left:${borderWidth}px solid black`,
  [CellBorderOptions.NONE]: () => `border:none`,
};
const RowBorderStyle = {
  [RowBorderOptions.TOP]: (borderWidth: number) => `border-top:${borderWidth}px solid black`,
  [RowBorderOptions.BOTTOM]: (borderWidth: number) => `border-bottom:${borderWidth}px solid black`,
  [RowBorderOptions.NONE]: () => `border:none`,
};
const Cell = styled.div<ICellStyleProps>`
  width:100%;
  ${(props) => CellBorderStyle[props.border](1)} ;
  ${(props) => props.border === CellBorderOptions.NONE ? 'border:none' : ''}
  padding-left:3px;
`;
const TextBlockWrapper = styled.div<ITextBlockWrapperProps>`
  display: flex;
  flex-direction: row;
  padding: ${(props) => props.hasPadding ? 20 : 0}px 13px;
  word-wrap: break-word;
  background: ${(props) => props.backgroundColor};
  ${getCenterOfPageStyle()}
  ${(props) => RowBorderStyle[props.border](1)} ;
  ${(props) => props.border === RowBorderOptions.NONE ? 'border:none' : ''}
`;
@inject('state')
@observer
export class TableRowBlockView extends BaseBlockView<TableRowBlockModel, IInjectedProps> {
  selectCell = (cellToSelect: ITableCell) => {
    this.props.content.row.cells.forEach((cell) => {
      if (cellToSelect.id === cell.id) {
        cell.isSelected = true;
      } else {
        cell.isSelected = false;
      }
    });
  }
  render() {
    const mentions = this.props.content.getUsedMentions(this.props.state.activeDesign.data);
    const cells = this.props.content.row.cells;
    const hasContent = mentions.length === 0 ? cells.length > 0 && !isDraftEmpty(this.props.content.row.cells[0].value) : mentions.some((mention) => {
      const linkedData = findLinkedDataById(mention, this.props.state.activeDesign.data);
      return (linkedData && linkedData.data !== null && linkedData.data !== undefined) || this.props.dataItem;
    });
    if (!hasContent && !this.props.inEditor) {
      return null;
    }
    return (
      <TextBlockWrapper
        backgroundColor={'white'}
        hasPadding={true}
        border={this.props.content.row.rowBorder}
        isSelected={false}
      >
        {this.props.content.row.cells.map((cell) => {
          return <Cell
            key={cell.id}
            border={cell.cellBorder}
            style={{
              color: cell.isSelected && this.props.inEditor ? 'green' : '#4f4f4f',
              width: '100%',
            }}
          >
            <DraftToHtml
              dataItem={this.props.dataItem}
              draft={cell.value}
              inEditor={this.props.inEditor}
            />
          </Cell>;

        })
        }

      </TextBlockWrapper >
    );
  }

}
